import u from "./highrise1587.mjs";
var c = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, d = /\\(\\)?/g, h = u(function(e) {
  var r = [];
  return e.charCodeAt(0) === 46 && r.push(""), e.replace(c, function(a, p, o, t) {
    r.push(o ? t.replace(d, "$1") : p || a);
  }), r;
});
export {
  h as default
};
